import two from '../assets/png/projects/two.png'
import eight from '../assets/png/projects/eight.png'
import nine from '../assets/png/projects/nine.png'
import eleven from '../assets/png/projects/eleven.png'
import twelve from '../assets/png/projects/twelve.png'
import thirteen from '../assets/png/projects/thirteen.png'
import quiz from '../assets/svg/projects/quiz.svg'
import wallpaper from '../assets/svg/projects/wallpaper.svg'

export const projectsData = [
    {
        id: 1,
        projectName: 'Blood-Givers',
        projectDesc: 'Blood Point” is an android application to collect or donate blood easily. Users who have an android phone & active internet connection can contact and start searching for a donor easily through this application.',
        tags: ['Java', 'Firebase', 'Google Maps API', 'Android SDK 17-28'],
        code: 'https://github.com/Deepankar0712/BloodBank-master',
        // demo: 'https://github.com/jyotirani123/BuyS_Monefy',
        image: eight
    },
    {
        id: 2,
        projectName: 'YouTube Clone',
        projectDesc: 'This project is clone of YouTube app using Youtube Data API where we can change, update our playlist, like and comment the videos and also can subscribe the channel.',
        tags: ['Java', 'YouTube Data API', 'Firebase'],
        code: '/',
        // demo: '/',
        image: two
    },
    {
        id: 3,
        projectName: 'News Feed App',
        projectDesc: 'This project provides news of all categories and user can search news for specific category also like sports, health, science, etc.',
        tags: ['Java', 'Firebase', 'News API'],
        code: 'https://github.com/Deepankar0712/News-App',
        // demo: 'https://prerna-gupta.web.app/',
        image: nine
    },
    {
        id: 4,
        projectName: 'Quiz App',
        projectDesc: 'It is a MCQs based quiz app for law students.',
        tags: ['Java', 'Firebase'],
        code: '/',
        // demo: 'https://todo-list-879cd.web.app/',
        image: quiz
    },
    {
        id: 5,
        projectName: 'Insta Saver',
        projectDesc: 'By using this app we can download the reels, posts, videos and IGTV by using URL.',
        tags: ['Java', ],
        code: 'https://github.com/Deepankar0712/Insta-Saver',
        // demo: 'https://pokedex-7df36.web.app/',
        image: eleven
    },
    {
        id: 6,
        projectName: 'Vchat App',
        projectDesc: 'It is like a meet app in which user can join through his id and password.',
        tags: ['Java', 'Firebase'],
        code: '/',
        // demo: 'https://prerna-gupta02.github.io/NameIt/',
        image: twelve
    },
    {
        id: 7,
        projectName: 'ROM (Restaurant Order Management)',
        projectDesc: 'In this app we can order food from home and we can also order food by sitting on a table in the restaurant.',
        tags: ['Java', 'MySQL', 'PHP', 'HTML'],
        code: '/',
        // demo: 'https://prerna-gupta02.github.io/WeatherApp/',
        image: thirteen
    },
    {
        id: 8,
        projectName: 'Wallpaper App',
        projectDesc: 'It gives various attractive and beautiful wallpapers which user can set on their mobiles directly from app.',
        tags: ['Java', 'Pixels API'],
        code: 'https://github.com/Deepankar0712/Wallpaper-App',
        // demo: 'https://prerna-gupta02.github.io/WeatherApp/',
        image: wallpaper
    },
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/